import { Component, Input, OnChanges } from '@angular/core';
import { HandlingUnitMasterDTO } from '../../../models/handling-unit-master';
import { groupUnitRows, LotUnitRow } from '../lot-unit-summary';

@Component({
  selector: 'lot-product-summary',
  templateUrl: './lot-product-summary.component.html'
})
export class LotProductSummaryComponent implements OnChanges {
  @Input() allHandlingUnits: HandlingUnitMasterDTO[] = [];
  @Input() lotId: number;

  public rows: LotUnitRow[] = [];

  ngOnChanges() {
    const huds = (this.allHandlingUnits ?? []).flatMap(hum => hum.handlingUnitDetails ?? []).filter(hud => hud.lotId == this.lotId);
    this.rows = groupUnitRows(huds, hud => hud.itemName ?? '', hud => [hud]);
  }
}
